import React, { useState, useEffect, useRef } from 'react';
import { FaChevronDown, FaChevronUp, FaShareAlt, FaCopy } from 'react-icons/fa';
import ShareSyntaxe from './ShareSyntaxe';
import { Tooltip } from 'react-tooltip';

const Accordion = ({ title, content, isInitiallyOpen = false, onToggle, network, syntax }) => {
  const [isOpen, setIsOpen] = useState(isInitiallyOpen);
  const [showShareIcons, setShowShareIcons] = useState(false);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    setIsOpen(isInitiallyOpen);
  }, [isInitiallyOpen]);

  useEffect(() => {
    if (isOpen && contentRef.current) {
      contentRef.current.style.maxHeight = `${contentRef.current.scrollHeight}px`;
    }
  }, [isOpen, showShareIcons]);

  const handleToggle = () => {
    const newIsOpen = !isOpen;
    setIsOpen(newIsOpen);
    if (onToggle) {
      onToggle(newIsOpen);
    }
  };

  const handleShareToggle = (e) => {
    e.stopPropagation();
    setShowShareIcons(!showShareIcons);
  };

  const handleCopy = () => {
    const textToCopy = `${network.name} - ${syntax.title}\n${syntax.content}`;
    navigator.clipboard.writeText(textToCopy).then(() => {
      setShowCopyModal(true);
      setTimeout(() => {
        setShowCopyModal(false);
      }, 2000);
    }).catch(err => {
      console.error('Erreur lors de la copie : ', err);
    });
  };

  return (
    <div className="border rounded-md mb-2">
      <style>
        {`
          @media (max-width: 768px) {
            #shareTooltip {
              display: none !important;
            }
          }
        `}
      </style>
      <button
        className="w-full text-left p-4 focus:outline-none flex justify-between items-center"
        onClick={handleToggle}
      >
        <h2 className="text-lg font-semibold">{title}</h2>
        {isOpen ? <FaChevronUp className="text-gray-500" /> : <FaChevronDown className="text-gray-500" />}
      </button>
      <div
        ref={contentRef}
        style={{
          maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px',
          overflow: 'hidden',
          transition: 'max-height 0.3s ease-in-out, opacity 0.3s ease-in-out',
          opacity: isOpen ? 1 : 0,
        }}
      >
        <div className="p-4 border-t">
          <div className="flex justify-between items-start">
            <p className="flex-grow">{content}</p>
            <div className="tooltip">
              <FaShareAlt 
                className="text-black cursor-pointer ml-4 mt-1 flex-shrink-0"
                size={18}
                onClick={handleShareToggle}
                data-tooltip-id="shareTooltip"
                data-tooltip-content="Partagé à un proche!"
                style={{ outline: 'none' }}
              />
              <Tooltip id="shareTooltip" place="top" />
            </div>
          </div>
          {showShareIcons && (
            <div className="mt-4 flex justify-end items-center space-x-2">
              <button 
                onClick={handleCopy} 
                className="flex items-center text-gray-900 hover:text-gray-700"
              >
                <FaCopy className="mr-2" size={16} />
                Copier
              </button>
              <ShareSyntaxe 
                syntax={syntax} 
                network={network} 
                onClose={() => setShowShareIcons(false)}
              />
            </div>
          )}
        </div>
      </div>
      {showCopyModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg animate-fade-in mx-4 sm:mx-0" style={{ maxWidth: '400px' }}>
            <div className="flex items-center justify-center mb-4">
              <FaCopy className="text-green-500 mr-2" size={24} />
              <span className="text-lg font-semibold text-center">Texte Copié !</span>
            </div>
            <p className="text-gray-700 text-center">
              Le texte a été copié dans le presse-papiers. Vous pouvez maintenant le coller où vous le souhaitez.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Accordion;